export default {
  getCourierValueExplain: '/courierScore/client/info'
}
